import React from 'react';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';

function ActivityStatCard(props) {

  const color = 'pink'

  return (

    <div className={"col-span-full sm:col-span-4 xl:col-span-2 bg-white shadow-1 rounded-sm border border-slate-200 cursor-pointer " +
        (props.active
            ? "border-" + color + "-400"
            : "")} onClick={props.onClick}>
      <div className="flex flex-col h-full text-center p-5">
        <div className="grow mb-1">
          <div className="inline-flex text-2xl justify-center items-center w-12 h-12 bg-slate-100 rounded-full mb-2">
            {props.icon}
          </div>
          {(((props.stat > -1)&&((typeof props.stat)!='string'))||
              ((props.stat !== '')&&((typeof props.stat)=='string'))) ?
              <h3 className="text-2xl text-pink-500 font-semibold mb-1">
                {(typeof props.stat)!='string'?<CountUp end={props.stat}/>:props.stat}
              </h3> :
              <h3 className="text-2xl text-pink-500 font-semibold mb-1">
                <div className="m-auto text-center mb-2">
                  {(typeof props.stat)!='string'?<CountUp end={0}/>:'❔'}
                </div>
              </h3>
          }
        </div>
        <div>
          <div className="text-sm font-bold text-slate-500">{props.name}</div>
        </div>
      </div>
    </div>
  );
}

export default ActivityStatCard;